import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  ALERT_REMOVE_ALERT_SET_BEGIN,
  ALERT_REMOVE_ALERT_SET_SUCCESS,
  ALERT_REMOVE_ALERT_SET_FAILURE,
  ALERT_REMOVE_ALERT_SET_DISMISS_ERROR,
} from './constants';
import { serviceRemove } from '../../../common/feathers';

export const removeAlertSet = serviceRemove('alertSets', {
  begin: ALERT_REMOVE_ALERT_SET_BEGIN,
  success: ALERT_REMOVE_ALERT_SET_SUCCESS,
  fail: ALERT_REMOVE_ALERT_SET_FAILURE,
});

export function dismissRemoveAlertSetError() {
  return {
    type: ALERT_REMOVE_ALERT_SET_DISMISS_ERROR,
  };
}

export function useRemoveAlertSet() {
  const dispatch = useDispatch();

  const { removeAlertSetPending, removeAlertSetError } = useSelector(
    state => ({
      removeAlertSetPending: state.alert.removeAlertSetPending,
      removeAlertSetError: state.alert.removeAlertSetError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(removeAlertSet(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissRemoveAlertSetError());
  }, [dispatch]);

  return {
    removeAlertSet: boundAction,
    removeAlertSetPending,
    removeAlertSetError,
    dismissRemoveAlertSetError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALERT_REMOVE_ALERT_SET_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeAlertSetPending: true,
        removeAlertSetError: null,
      };

    case ALERT_REMOVE_ALERT_SET_SUCCESS:
      // The request is success
      return {
        ...state,
        removeAlertSetPending: false,
        removeAlertSetError: null,
      };

    case ALERT_REMOVE_ALERT_SET_FAILURE:
      // The request is failed
      return {
        ...state,
        removeAlertSetPending: false,
        removeAlertSetError: action.data.error,
      };

    case ALERT_REMOVE_ALERT_SET_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeAlertSetError: null,
      };

    default:
      return state;
  }
}
